import { useState, useEffect } from 'react';
import { getLinkPreview } from '@/lib/link-preview/api';
import type { LinkPreviewData } from '@/lib/link-preview/api';

export function useLinkPreview(url: string) {
  const [preview, setPreview] = useState<LinkPreviewData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!url) return;

    let mounted = true;
    setLoading(true);
    setError(null);

    getLinkPreview(url)
      .then(data => {
        if (mounted) {
          setPreview(data);
        }
      })
      .catch(err => {
        if (mounted) {
          setError(err);
          console.error('Error fetching link preview:', err);
        }
      })
      .finally(() => {
        if (mounted) {
          setLoading(false);
        }
      });

    return () => {
      mounted = false;
    };
  }, [url]);

  return { preview, loading, error };
}